// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"custom-dropdown-m__dropdown__3_v-2"};